import { localStorage } from 'src/lib/localStorage';

const defaultOptions = () => ({
  store: localStorage,
  clientKey: new URLSearchParams(window.location.search).get('clientKey')
});

const setSession = (session, opts = {}) => {
  const { store, clientKey } = { ...defaultOptions(), ...opts };

  store.setItem(`integration_jira_session_${clientKey}`, session);
};

const deleteSession = (opts = {}) => {
  const { store, clientKey } = { ...defaultOptions(), ...opts };

  store.setItem(`integration_jira_session_${clientKey}`, undefined);
  store.setItem(`integration_jira_session`, undefined);
};

const onSessionChange = (cb, opts = {}) => {
  const { store, clientKey } = { ...defaultOptions(), ...opts };

  store.onChange('integration_jira_session', cb);
  store.onChange(`integration_jira_session_${clientKey}`, val => {
    cb(val);
  });
};

const getSession = (opts = {}) => {
  const { store, clientKey } = { ...defaultOptions(), ...opts };

  return (
    store.getItem(`integration_jira_session_${clientKey}`)
    || store.getItem('integration_jira_session')
  );
};

export { deleteSession,
  getSession,
  onSessionChange,
  setSession };
